import { render, staticRenderFns } from "./ReferralsGeneralPendingPayouts.vue?vue&type=template&id=702849a8&"
import script from "./ReferralsGeneralPendingPayouts.vue?vue&type=script&lang=js&"
export * from "./ReferralsGeneralPendingPayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports